export const FORM_ERROR_ALERT_MESSAGES = {
	defaultErrorMessage:
		'Required Fields are missing, incomplete, or entered incorrectly. ' +
		'Correct the issues in the highlighted fields below before saving.'
};
